var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-orders__wrapper-2"},[(_vm.isView('ddmp'))?_c('ViewDdmp'):_vm._e(),(_vm.isView('ddmi'))?_c('ViewDdmi'):_vm._e(),(_vm.isView('incident'))?_c('ViewIncident'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }